<div class="main-container">
  <div class="left-content">
    <div class="logo-container">
      <img alt="Smarterplan" class="logo" src="../assets/images/logos/logo-rvb.png">
    </div>
    
    <h1>{{'title-start' | translate}} <span>SmarterPlan</span> {{'title-end' | translate}}
    </h1>
    <h2>{{'slogan-start' | translate}} <span>{{'slogan-span' | translate}}</span>
      {{'slogan-end' | translate }}. </h2>
    <div class="not-connected" *ngIf="!authenticator.user">
      <p class="contact">{{ 'auth.connectMessage' | translate}}</p>
      <amplify-authenticator [formFields]="formFields">
        <ng-template amplifySlot="authenticated" let-user="user" let-signOut="signOut">
          <h2>Welcome, {{ user.username }}!</h2>
          <button (click)="signOut()">Sign Out</button>
        </ng-template>
      </amplify-authenticator>

      <p class="help">{{'Help' | translate}}
        <span (click)="openSupportForm()" data-testid="new-support-btn">
          {{'Contact support'|translate}}</span>
      </p>

      <p class="cvg">{{'By registering, you accept our' | translate}}
        <a href="https://www.smarterplan.io/mentions-legales/">{{'Terms'
          | translate}}</a>
        {{'and' | translate}}<a href="https://www.smarterplan.io/politique-de-confidentialite/"> {{'Privacy Policy'
          |
          translate}}</a>.
      </p>
    </div>
    <div class="loading" *ngIf="loading">
      <lib-loader></lib-loader>
    </div>
  </div>
  <div class="image-container">
    <img class="image-background" alt="" src="../../assets/images/landing-image.jpg">
    <div class="div-logo logo-platform">
      <img class="image-logo" alt="" src="../../assets/images/logos/logo-plateforme-web.jpg">
    </div>
    <div class="div-logo logo-museum">
      <img class="image-logo" alt="" src="../../assets/images/logos/logo-museum.png">
    </div>

  </div>
</div>